export default "__VITE_ASSET__DG97Iouz__"